import {
  GitMergeIcon,
  GitPullRequestClosedIcon,
  GitPullRequestDraftIcon,
  GitPullRequestIcon,
} from '@primer/octicons-react'

export function getPRStatusIcon(status: string) {
  switch (status) {
    case 'DRAFT':
      return <GitPullRequestDraftIcon />
    case 'OPEN':
      return <GitPullRequestIcon />
    case 'CLOSED':
      return <GitPullRequestClosedIcon />
    case 'MERGED':
      return <GitMergeIcon />
    default:
      return <GitPullRequestIcon />
  }
}
